import { render, staticRenderFns } from "./compentencies.vue?vue&type=template&id=ae18d316"
import script from "./compentencies.vue?vue&type=script&lang=js"
export * from "./compentencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports